import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Account from "app/pages/Account/Account";
import { logout } from "app/pages/Auth/AuthActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { useCallback, useEffect } from "react";
import { brandPropTypes } from "app/utils/propTypes";
import { fetchSearchMyBookingNotification } from "app/pages/Account/SearchMyBooking/searchMyBookingActionCreators";
import { fetchMyBookingsNotification } from "app/pages/Account/MyBookings/myBookingsActionCreators";

const AccountContainer = ({
	logout = () => {},
	isAuthenticated = false,
	brand,
	enableSponsorship = false,
	isSdp = false,
	shop,
	email,
	fetchMyBookingsNotification = () => {},
	fetchSearchMyBookingNotification = () => {},
	searchMyBooking = {},
}) => {
	const navigate = useNavigate();

	const onLogout = useCallback(() => {
		logout();
		navigate({ pathname: "/" });
	}, []);

	useEffect(() => {
		if (isAuthenticated) {
			fetchMyBookingsNotification({
				shop,
				brand,
				email,
			});
		} else if (searchMyBooking?.booking?.bookingReference) {
			fetchSearchMyBookingNotification({
				brand,
				shop,
				email,
				bookingReference: searchMyBooking?.booking?.bookingReference,
			});
		}
	}, [isAuthenticated]);

	return (
		<Account
			onLogout={onLogout}
			enableSponsorship={enableSponsorship}
			brand={brand}
			isAuthenticated={isAuthenticated}
			isSdp={isSdp}
		/>
	);
};

AccountContainer.propTypes = {
	logout: PropTypes.func,
	enableSponsorship: PropTypes.bool,
	brand: brandPropTypes,
	isAuthenticated: PropTypes.bool,
	isSdp: PropTypes.bool,
	email: PropTypes.string,
	shop: PropTypes.string,
	searchMyBooking: PropTypes.object,
	fetchMyBookingsNotification: PropTypes.func,
	fetchSearchMyBookingNotification: PropTypes.func,
};

const mapStateToProps = state => ({
	isAuthenticated: isAuthenticated(state),
	brand: state.brand.code,
	shop: state.shop,
	email: state.email,
	enableSponsorship: state.partner.enableSponsorship,
	isSdp: state.partner.showSmartDPOnRootUrl,
	searchMyBooking: state.searchMyBooking,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{ logout, fetchMyBookingsNotification, fetchSearchMyBookingNotification },
		dispatch
	);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AccountContainer);
